import { ActivityLogTypeEnum } from '@/@data'
import { LiftActivityLog } from '@/components/log/LiftActivityLog'
import Link from '@/components/Link';

export const EmployerActivityLog = () => {
  const { __ } = useTranslator();

  return (
    <LiftActivityLog
      object_type={ActivityLogTypeEnum.Company}
      breadcrumb={
        <Link color='inherit' href='/cms/employer'>
          {__('Employer Management')}
        </Link>
      }
    />
  )
}
